import {
  getHeraConfigurationEndpointOperatorHeraConfigurationGet,
  updateHeraConfigurationEndpointOperatorHeraConfigurationPut,
} from "@/hera-api/client";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export function useHeraConfiguration(enabled = true) {
  return useQuery({
    queryKey: ["hera-configuration"],
    queryFn: async () => {
      const response =
        await getHeraConfigurationEndpointOperatorHeraConfigurationGet();
      if (response.error) {
        throw new Error("Failed to fetch HERA configuration");
      }
      return response.data;
    },
    enabled,
  });
}

export function useUpdateHeraConfiguration() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: {
      address_line1?: string | null;
      address_line2?: string | null;
      city?: string | null;
      state?: string | null;
      zipcode?: string | null;
      support_email?: string | null;
      support_phone?: string | null;
      sales_email?: string | null;
      sales_phone?: string | null;
      email?: string | null;
      phone?: string | null;
      check_processing_fee?: string | null;
      global_mail_cc?: string | null;
      needs_attention_send_to_registrant?: boolean;
    }) => {
      const response =
        await updateHeraConfigurationEndpointOperatorHeraConfigurationPut({
          body: data,
        });
      if (response.error) {
        throw new Error("Failed to update HERA configuration");
      }
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["hera-configuration"] });
    },
  });
}
